/*
 * Image component that uses jquery.unveil to load
 * and jquery.imagefill when the image isn't the cropped version.
 */

import PropTypes from 'prop-types';

import React from 'react';
import createReactClass from 'create-react-class';
import cx from 'classnames';
import $ from 'jquery';
import { Helper as MSHelper } from 'stores/anyguide/model';
import imagesLoaded from 'imagesloaded';
import './index.scss';

imagesLoaded.makeJQueryPlugin($);

export default createReactClass({
  displayName: 'Image',
  mixins: [MSHelper],
  propTypes: {
    assetId: PropTypes.number,
    size: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    unveilImmediately: PropTypes.bool,
    unveilEventSource: PropTypes.object, // Used to possibly provide a "js-signal" Signal object
    // where callbacks can be registered, so that images unveiled when event occurs (such as when sidemenu opens)
  },

  getDefaultProps() {
    return {
      size: 'large_square',
    };
  },

  getInitialState() {
    return {
      asset: undefined,
      loading: true,
      unveiled: false,
    };
  },

  model: {
    type: 'asset',
    id: 'assetId',
    onState(attrs) {
      this.setState({
        asset: attrs,
        unveiled: false,
        loading: false,
      });
    },
  },

  componentDidMount() {
    const $img = $(this.refs.img);
    this._setupUnveil($img);
  },

  componentDidUpdate() {
    const $img = $(this.refs.img);
    this._setupUnveil($img);
  },

  _setupUnveil($img) {
    const _this = this;
    const { unveilEventSource } = this.props;

    if (!this.state.unveiled && !this.state.loading) {
      $img.unveil(0, () => {
        // XXX This is a silent change of the state.
        // This doesn't happen very ofthen but I want
        // to keep track of this, but not have it rerender.
        _this.state.unveiled = true;
        $img.imagesLoaded(_this.imageLoaded);
      });
      if (_this.props.unveilImmediately) {
        $img.trigger('unveil');
      }
      if (unveilEventSource) {
        // WEB-3067
        unveilEventSource.add(() => {
          $img.trigger('unveil');
        });
      }
    }
  },

  _getPictureSrc() {
    if (this.state.loading) {
      return require('../images/img-placeholder.gif').default;
    }
    return this.state.asset.file[this.props.size].url;
  },

  _assetNeedsCropping() {
    if (this.state.loading) {
      return false;
    }
    return !this.state.asset.processed;
  },

  imageLoaded(e) {
    const $img = $(e.elements[0]);

    if (this.state.unveiled && this._assetNeedsCropping()) {
      $($img.parent()).imagefill();
    }
  },

  render() {
    const placeholderSrc = require('../images/img-placeholder.gif').default;
    const imageClasses = cx({
      Image: true,
      'is-processed': !this._assetNeedsCropping(),
    });

    return (
      <div className={`${imageClasses} ${this.props.className}`}>
        <img src={placeholderSrc} ref="img" data-src={this._getPictureSrc()} />
      </div>
    );
  },
});
